import React from 'react';
import { ChevronDownIcon } from '@radix-ui/react-icons';

import { MultiSelectDropdown } from '../../../components/select-dropdown';
import { Bloc, BlocContent } from '../../../routes/project/components/step-drawer';
import { TagLabel } from '../../tags/components/styled-tags-components';

export interface SelectProps {
  label: string;
  value: string[];
  placeHolder?: string;
  options: any[];
  onSelect?: (el: any) => void;
  disabled?: boolean;
  name?: string;
}

export const MultiSelectItem: React.FC<SelectProps> = ({
  label,
  value,
  onSelect,
  options,
  name,
}) => {
  const handleChange = (newValue: string, isChecked: boolean) => {
    const values = value && Array.isArray(value) ? value : [];

    isChecked ? values.push(newValue) : values.splice(values.indexOf(newValue), 1);

    onSelect(values);
  };

  return (
    <MultiSelectDropdown
      trigger={(values) => (
        <Bloc data-row={true}>
          <label>{label}</label>

          <BlocContent>
            {values &&
              values.split(',').map((value) => (
                <TagLabel>
                  <span>{value}</span>
                </TagLabel>
              ))}

            <ChevronDownIcon />
          </BlocContent>
        </Bloc>
      )}
      title={name}
      selectedOptions={value}
      options={options}
      onValueChange={handleChange}
    />
  );
};
